import script from "./IndicatorsList.vue?vue&type=script&setup=true&lang=js"
export * from "./IndicatorsList.vue?vue&type=script&setup=true&lang=js"

import "./IndicatorsList.vue?vue&type=style&index=0&id=6fc10f79&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fc10f79"]])

export default __exports__